import React, { useState, useEffect } from "react";
import { overlayButtonStyle } from "../../../utils/layout";
import XframeContainer from "../xframedItems/XframeContainer";
import BibleStudyList from "./BibleStudyList";
import Button from "react-bootstrap/Button";
import BibleStudyEmbed from "./BibleStudyEmbed";

function BibleStudyXframe() {
  const [xframe, setXframe] = useState();
  const [name, setName] = useState("");
  const [file, setFile] = useState();

  const isLandscape = () =>
      window.matchMedia("(orientation:landscape)").matches,
    [orientation, setOrientation] = useState(
      isLandscape() ? "landscape" : "portrait"
    ),
    onWindowResize = () => {
      clearTimeout(window.resizeLag);
      window.resizeLag = setTimeout(() => {
        delete window.resizeLag;
        setOrientation(isLandscape() ? "landscape" : "portrait");
      }, 200);
    };

  useEffect(
    () => (
      onWindowResize(),
      window.addEventListener("resize", onWindowResize),
      () => window.removeEventListener("resize", onWindowResize)
    ),
    []
  );

  return (
    <>
    {xframe && (
      <>
        <Button
          style={overlayButtonStyle(0)}
          onClick={() => setXframe()}
        >
          Select a new Lesson
        </Button>
        <XframeContainer url={xframe} name={name} orientation={orientation} props={file}/>
      </>
    )}
    {file && (
      <>
        <Button
          style={overlayButtonStyle(0)}
          onClick={() => setFile()}
        >
          Select a new Lesson
        </Button>
        <BibleStudyEmbed file={file}/>
      </>
    )}
    {file === undefined && xframe === undefined && <BibleStudyList setXframe={setXframe} setFile={setFile} />}
      
    </>
  );
}

export default BibleStudyXframe;
